import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { APPROVALS_PERMISSIONS } from "@/app/nav";
import { ApprovalsWorkspace } from "@/features/approvals/ApprovalsWorkspace";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type ApprovalsSearch = { batch?: string } & PageSearch;

export const approvalsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "approvals",
  // Set, never omit, the key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): ApprovalsSearch => ({
    batch: typeof search.batch === "string" && search.batch !== "" ? search.batch : undefined,
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, APPROVALS_PERMISSIONS),
  component: ApprovalsWorkspace,
});
